import {
    AppUser,
    UserAction,
    UserActionTypes
} from "interfaces/context/appContextInterfaces";

const defaultState: AppUser = {
    isInitialized: false,
    logged_in: false,
    view_bookings: false,
    company: null,
    location: null,
    cropped_name: "",
    email: "",
    favorite_posts: [],
    name: "",
    id: null
};

export const userReducer = (state: AppUser, action: UserAction) => {
    switch (action.type) {
    case UserActionTypes.updateUser: {
        const updatedState = {
            ...state,
            ...action.payload
        };
        return updatedState;
    }
    case UserActionTypes.resetUser: {
        return defaultState;
    }
    default: {
        return state;
    }
    }
};
